import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

function Support() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // In production, this would send to your support email or ticketing system
    setSubmitted(true);
    setTimeout(() => {
      setFormData({ name: '', email: '', subject: '', message: '' });
      setSubmitted(false);
    }, 5000);
  };

  return (
    <div className="container" style={{ maxWidth: '900px', padding: '40px 20px' }}>
      <button
        onClick={() => navigate('/')}
        style={{
          background: 'transparent',
          border: '2px solid #667eea',
          color: '#667eea',
          padding: '10px 20px',
          borderRadius: '6px',
          marginBottom: '30px',
          cursor: 'pointer',
          fontSize: '1rem'
        }}
      >
        ← Back to Home
      </button>

      <div className="card">
        <h1 style={{ fontSize: '2.5rem', marginBottom: '10px' }}>Support & Contact</h1>
        <p style={{ color: '#666', marginBottom: '40px', fontSize: '1.1rem' }}>
          We're here to help! Get in touch with our support team.
        </p>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '40px', marginBottom: '50px' }}>
          {/* Contact Methods */}
          <div>
            <h2 style={{ fontSize: '1.5rem', marginBottom: '20px', color: '#667eea' }}>Get in Touch</h2>

            <div style={{ marginBottom: '25px' }}>
              <h3 style={{ fontSize: '1.1rem', marginBottom: '8px', display: 'flex', alignItems: 'center' }}>
                📧 Email Support
              </h3>
              <p style={{ color: '#666', marginBottom: '5px' }}>
                <a href="mailto:support@aiandautomationmarketing.com" style={{ color: '#667eea', textDecoration: 'none' }}>
                  support@aiandautomationmarketing.com
                </a>
              </p>
              <p style={{ fontSize: '0.9rem', color: '#999' }}>Response time: Within 24 hours</p>
            </div>

            <div style={{ marginBottom: '25px' }}>
              <h3 style={{ fontSize: '1.1rem', marginBottom: '8px', display: 'flex', alignItems: 'center' }}>
                💬 Live Chat
              </h3>
              <p style={{ color: '#666', marginBottom: '5px' }}>
                Available Monday-Friday, 9 AM - 5 PM EST
              </p>
              <button
                style={{
                  background: '#667eea',
                  color: 'white',
                  border: 'none',
                  padding: '10px 20px',
                  borderRadius: '6px',
                  cursor: 'pointer',
                  fontSize: '0.95rem',
                  marginTop: '10px'
                }}
                onClick={() => alert('Live chat will be available soon!')}
              >
                Start Chat
              </button>
            </div>

            <div style={{ marginBottom: '25px' }}>
              <h3 style={{ fontSize: '1.1rem', marginBottom: '8px', display: 'flex', alignItems: 'center' }}>
                📚 Documentation
              </h3>
              <p style={{ color: '#666', marginBottom: '5px' }}>
                Check out our comprehensive guides and tutorials
              </p>
              <a
                href="/docs"
                style={{
                  color: '#667eea',
                  textDecoration: 'none',
                  fontSize: '0.95rem'
                }}
              >
                Browse Documentation →
              </a>
            </div>

            <div style={{ marginBottom: '25px' }}>
              <h3 style={{ fontSize: '1.1rem', marginBottom: '8px', display: 'flex', alignItems: 'center' }}>
                🎥 Video Tutorials
              </h3>
              <p style={{ color: '#666', marginBottom: '5px' }}>
                Watch step-by-step video guides
              </p>
              <a
                href="https://youtube.com/@viraffle"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  color: '#667eea',
                  textDecoration: 'none',
                  fontSize: '0.95rem'
                }}
              >
                Visit YouTube Channel →
              </a>
            </div>
          </div>

          {/* Contact Form */}
          <div>
            <h2 style={{ fontSize: '1.5rem', marginBottom: '20px', color: '#667eea' }}>Send Us a Message</h2>

            {submitted ? (
              <div style={{
                background: '#d4edda',
                border: '1px solid #c3e6cb',
                color: '#155724',
                padding: '20px',
                borderRadius: '8px',
                textAlign: 'center'
              }}>
                <h3 style={{ marginBottom: '10px' }}>✓ Message Sent!</h3>
                <p style={{ margin: 0 }}>
                  Thank you for contacting us. We'll get back to you within 24 hours.
                </p>
              </div>
            ) : (
              <form onSubmit={handleSubmit}>
                <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}>Name</label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  style={{
                    width: '100%',
                    padding: '12px',
                    marginBottom: '20px',
                    border: '1px solid #ddd',
                    borderRadius: '6px',
                    fontSize: '1rem'
                  }}
                />

                <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}>Email</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  style={{
                    width: '100%',
                    padding: '12px',
                    marginBottom: '20px',
                    border: '1px solid #ddd',
                    borderRadius: '6px',
                    fontSize: '1rem'
                  }}
                />

                <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}>Subject</label>
                <select
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                  style={{
                    width: '100%',
                    padding: '12px',
                    marginBottom: '20px',
                    border: '1px solid #ddd',
                    borderRadius: '6px',
                    fontSize: '1rem'
                  }}
                >
                  <option value="">Select a topic...</option>
                  <option value="technical">Technical Issue</option>
                  <option value="billing">Billing & Subscriptions</option>
                  <option value="feature">Feature Request</option>
                  <option value="integration">GHL Integration Help</option>
                  <option value="general">General Question</option>
                  <option value="other">Other</option>
                </select>

                <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}>Message</label>
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  rows="6"
                  style={{
                    width: '100%',
                    padding: '12px',
                    marginBottom: '20px',
                    border: '1px solid #ddd',
                    borderRadius: '6px',
                    fontSize: '1rem',
                    fontFamily: 'inherit',
                    resize: 'vertical'
                  }}
                  placeholder="Please describe your issue or question..."
                />

                <button
                  type="submit"
                  style={{
                    width: '100%',
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    color: 'white',
                    border: 'none',
                    padding: '15px',
                    borderRadius: '8px',
                    fontSize: '1.1rem',
                    fontWeight: 'bold',
                    cursor: 'pointer'
                  }}
                >
                  Send Message
                </button>
              </form>
            )}
          </div>
        </div>

        {/* FAQ Section */}
        <div style={{ borderTop: '2px solid #e0e0e0', paddingTop: '40px', marginTop: '40px' }}>
          <h2 style={{ fontSize: '1.8rem', marginBottom: '30px', color: '#667eea' }}>Frequently Asked Questions</h2>

          <div style={{ marginBottom: '30px' }}>
            <h3 style={{ fontSize: '1.2rem', marginBottom: '10px', color: '#333' }}>
              How do I install ViRaffle from the GHL Marketplace?
            </h3>
            <p style={{ color: '#666', lineHeight: '1.6' }}>
              Visit the <a href="https://marketplace.gohighlevel.com" target="_blank" rel="noopener noreferrer" style={{ color: '#667eea' }}>GHL Marketplace</a>,
              search for "ViRaffle," and click "Install." You'll be prompted to authorize the app to access your GHL account.
              After authorization, you'll be redirected to complete your registration and choose a subscription plan.
            </p>
          </div>

          <div style={{ marginBottom: '30px' }}>
            <h3 style={{ fontSize: '1.2rem', marginBottom: '10px', color: '#333' }}>
              Can I change my subscription plan?
            </h3>
            <p style={{ color: '#666', lineHeight: '1.6' }}>
              Yes! You can upgrade or downgrade your plan at any time from your account dashboard. Upgrades take effect
              immediately, while downgrades apply at the end of your current billing period.
            </p>
          </div>

          <div style={{ marginBottom: '30px' }}>
            <h3 style={{ fontSize: '1.2rem', marginBottom: '10px', color: '#333' }}>
              How does winner selection work?
            </h3>
            <p style={{ color: '#666', lineHeight: '1.6' }}>
              ViRaffle uses a cryptographically secure random number generator to ensure fair winner selection.
              Each ticket has an equal chance of winning, and the selection process is transparent and auditable.
            </p>
          </div>

          <div style={{ marginBottom: '30px' }}>
            <h3 style={{ fontSize: '1.2rem', marginBottom: '10px', color: '#333' }}>
              Can I run multiple raffles simultaneously?
            </h3>
            <p style={{ color: '#666', lineHeight: '1.6' }}>
              Yes! All paid plans support multiple active raffles. The number of concurrent raffles depends on your
              subscription tier (Free: 1/month, Starter: 5/month, Professional: 25/month, Scale: 100/month, Agency: Unlimited).
            </p>
          </div>

          <div style={{ marginBottom: '30px' }}>
            <h3 style={{ fontSize: '1.2rem', marginBottom: '10px', color: '#333' }}>
              Is my data secure?
            </h3>
            <p style={{ color: '#666', lineHeight: '1.6' }}>
              Absolutely. We use industry-standard encryption (SSL/TLS) for all data transmission, store sensitive data
              encrypted at rest, and never share your information with third parties. See our{' '}
              <a href="/privacy" style={{ color: '#667eea' }}>Privacy Policy</a> for complete details.
            </p>
          </div>

          <div style={{ marginBottom: '30px' }}>
            <h3 style={{ fontSize: '1.2rem', marginBottom: '10px', color: '#333' }}>
              Do you offer refunds?
            </h3>
            <p style={{ color: '#666', lineHeight: '1.6' }}>
              We do not offer refunds for partial billing periods. If you cancel your subscription, you'll retain
              access until the end of your current billing cycle. For exceptional circumstances, please contact our
              support team.
            </p>
          </div>

          <div style={{ marginBottom: '30px' }}>
            <h3 style={{ fontSize: '1.2rem', marginBottom: '10px', color: '#333' }}>
              Can I export my raffle data?
            </h3>
            <p style={{ color: '#666', lineHeight: '1.6' }}>
              Yes! You can export participant lists, entry data, and winner information in CSV format from your
              raffle dashboard. This feature is available on all paid plans.
            </p>
          </div>
        </div>

        {/* Business Hours */}
        <div style={{ background: '#f8f9fa', padding: '30px', borderRadius: '10px', marginTop: '40px' }}>
          <h2 style={{ fontSize: '1.5rem', marginBottom: '20px', color: '#667eea' }}>Support Hours</h2>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
            <div>
              <p style={{ margin: '8px 0', color: '#333' }}>
                <strong>Monday - Friday:</strong> 9:00 AM - 5:00 PM EST
              </p>
              <p style={{ margin: '8px 0', color: '#333' }}>
                <strong>Saturday:</strong> 10:00 AM - 2:00 PM EST
              </p>
              <p style={{ margin: '8px 0', color: '#333' }}>
                <strong>Sunday:</strong> Closed
              </p>
            </div>
            <div>
              <p style={{ margin: '8px 0', color: '#666', fontSize: '0.95rem' }}>
                💡 <strong>Pro Tip:</strong> Agency plan subscribers get priority support with faster response times!
              </p>
              <p style={{ margin: '8px 0', color: '#666', fontSize: '0.95rem' }}>
                📧 Email support is monitored 24/7, and we aim to respond within 24 hours.
              </p>
            </div>
          </div>
        </div>

        {/* Footer Links */}
        <div style={{
          marginTop: '50px',
          paddingTop: '30px',
          borderTop: '2px solid #e0e0e0',
          textAlign: 'center',
          color: '#666'
        }}>
          <p style={{ fontSize: '0.9rem' }}>
            © {new Date().getFullYear()} ViRaffle. All rights reserved.
          </p>
          <p style={{ fontSize: '0.85rem', marginTop: '10px' }}>
            <a href="/privacy" style={{ color: '#667eea', marginRight: '20px' }}>Privacy Policy</a>
            <a href="/terms" style={{ color: '#667eea' }}>Terms of Service</a>
          </p>
        </div>
      </div>
    </div>
  );
}

export default Support;
